import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import dispatchVerificationService from '../services/dispatch-verification.service';
import { setMessage } from './message';

export const fetchPackingSlipDropdown = createAsyncThunk(
    'dispatchVerification/fetchPackingSlipDropdown',
    async ({ page, pagesize, search, groupId, ordering }, thunkAPI) => {
        try {
            const response = await dispatchVerificationService.getPackingSlipDropdown(
                page,
                pagesize,
                search,
                groupId,
                ordering,
            );
            return response.data;
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue(message);
        }
    },
);

export const verifyPackingSlip = createAsyncThunk(
    'dispatchVerification/verifyPackingSlip',
    async ({ page, pagesize, search, groupId, ordering, slip_no }, thunkAPI) => {
        try {
            const response = await dispatchVerificationService.verifyPackingSlip(
                page,
                pagesize,
                search,
                groupId,
                ordering,
                slip_no // Put slip_no at the end
            );
            return response.data;
        } catch (error) {
            const message =
                (error.response?.data?.message) || error.message || error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue(message);
        }
    }
)


const initialState = {
    data: [], // Ensure the data is always an empty array initially
    list: [],
    loading: false,
    totalRecord: 0,
    totalPages: 0,
    currentPage: 1,
    status: 'idle',
    error: null,
    hasMore: true,
};

const dispatchVerificationSlice = createSlice({
    name: 'stockverify',
    initialState,
    reducers: {
        setLoading: (state, action) => {
            state.loading = action.payload;
        },
        resetPackingSlip: state => {
            state.data = [];
            state.totalRecord = 0;
            state.status = 'idle';
        },
    },
    extraReducers: builder => {
        builder
            .addCase(fetchPackingSlipDropdown.pending, state => {
                state.status = 'loading';
            })
            .addCase(fetchPackingSlipDropdown.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload?.data || [];
                state.list = [...state.list, ...action.payload.data];
                state.hasMore = !!action.payload.next;
            })
            .addCase(fetchPackingSlipDropdown.rejected, (state, action) => {
                state.status = 'failed';
                state.loading = false;
            });

        builder
            .addCase(verifyPackingSlip.pending, state => {
                state.status = 'loading';
            })
            .addCase(verifyPackingSlip.fulfilled, (state, action) => {
                console.log(action)
                state.status = 'succeeded';
                const fetchedPage = action.payload.page || state.currentPage;
                state.data = action.payload?.results?.data || []; // Update to match your API response
                state.totalRecord = action.payload.count || 0; // Handle count (total records)
                state.totalPages = action.payload.totalPages || 0; // Handle totalPages
                state.currentPage = action.payload.next ? fetchedPage + 1 : fetchedPage;
                state.list = [...state.list, ...action?.payload?.results?.data];
                state.hasMore = !!action.payload.next;
            })
            .addCase(verifyPackingSlip.rejected, (state, action) => {
                state.status = 'failed';
                state.loading = false;
            });
    },
});

export const { resetPackingSlip } =
    dispatchVerificationSlice.actions;
const { reducer } = dispatchVerificationSlice;
export default reducer;
